import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { FacilitatorService } from '../services/facilitator.service';
import { UserRolesService } from '../services/user-roles.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-edit-facilitator',
    templateUrl: './edit-facilitator.component.html',
    styleUrls: ['./edit-facilitator.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditFacilitatorComponent implements OnInit, OnChanges {
  @Output() updatedFacilitator = new EventEmitter<any>();
  private subscription: Subject<void> = new Subject<void>();
  @Input() masterData: any;
  @Input() facilitatorDetails: any;
  firstName: string = '';
  lastName: string = '';
  countryList: Array<any>;
  stateList: Array<any>;
  cityList: Array<any>;
  functionList: Array<any>;
  serviceList: Array<any>;
  jobLevelList: Array<any>;
  industryList: Array<any>;
  sectorList: Array<any>;
  selectedEmail: string = '';
  selectedCountry: number = 0;
  selectedCity: number = 0;
  selectedService: number = 0;
  selectedSector: number = 0;
  selectedState: number = 0;
  selectedFunction: number = 0;
  selectedIndustry: number = 0;
  selectedLevel: number = 0;
  roleId: number;
  loggedInUserID: number;

  showEditLabel: boolean = false;
  showFooter: boolean = false;
  showArrow: boolean;
  disableName: boolean;
  disableEmail: boolean;
  disableField: boolean = true;
  disableRadioButtons: boolean;
  disableSave: boolean;
  disableCountry: boolean;
  disableState: boolean;
  disableCity: boolean;
  disableFunction: boolean;
  disableService: boolean;
  disableIndustry: boolean;
  disableSector: boolean;
  disableLevel: boolean;
  error: boolean;
  selectedCertification: number;
  imIntrestedWith: string = '';
  iEnjoyBecause: string = '';
  iBring: string = '';
  disableimIntrestedWith: boolean = false;
  disableiEnjoyBecause: boolean = false;
  disableiBring: boolean = false;
  isMDRData: boolean = false;
  editMode: boolean = false;
  functionText: boolean = false;
  serviceAreaText: boolean = false;
  industryText: boolean = false;
  sectorText: boolean = false;
  selectedFunctionText: string = '';
  selectedServiceText: string = '';
  selectedIndustryText: string = '';
  selectedSectorText: string = '';
  selectedDeliveryMethods: Array<any> = [];
  deliveryMethods: Array<any> = [];

  constructor(private facilitatorService: FacilitatorService, private userRoleService: UserRolesService) { }

  ngOnInit() {
    this.applyValidation();
    this.checkError();
  }
  ngOnChanges() {
    this.applyValidation();
    this.intialLoading();
    this.checkError();
  }


  intialLoading() {
    const name = this.facilitatorDetails?.Name || '';
    if (name) {
      this.firstName = name.split(' ')[0];
      this.lastName = name.split(' ')[1];
    }
    if (this.masterData) {
      this.countryList = this.masterData['Countries'] || [];
      this.stateList = this.masterData['States'] || [];
      this.cityList = this.masterData['Cities'] || [];
      this.functionList = this.masterData['ServiceFunctions'] || [];
      this.serviceList = this.masterData['ServiceAreas'] || [];
      this.jobLevelList = this.masterData['JobLevels'] || [];
      this.industryList = this.masterData['Industries'] || [];
      this.sectorList = this.masterData['Sectors'] || [];
      this.deliveryMethods = this.masterData['SessionFormat'] ? this.masterData['SessionFormat']
        .filter((data, index, self) =>
          (data["SessionFormatID"] == 1 || data["SessionFormatID"] == 2 || data["SessionFormatID"] == 6) &&
          self.findIndex(item => item.SessionFormatID === data.SessionFormatID) === index
        ) : [];

      if (this.editMode) {
        this.loadDropdownConditionally()
      }
    }
    //Bug 3757919 fix - Persisting data on modal close and cancel button click
    if (this.facilitatorDetails && Object.keys(this.facilitatorDetails).length) {
      this.selectedEmail = this.facilitatorDetails.Email;
      this.selectedCountry = this.facilitatorDetails.CountryID;
      if (this.selectedCountry) {
        this.stateList = this.stateList.filter(x => x.CountryID == this.selectedCountry);
      }
      this.selectedState = this.facilitatorDetails.StateID;
      if (this.selectedState) {
        this.cityList = this.cityList.filter(x => x.StateID == this.selectedState);
      } else {
        this.cityList = [];
      }
      this.selectedCity = this.facilitatorDetails.CityID;

      this.selectedFunction = this.facilitatorDetails.ServiceFunctionID;
      this.selectedFunctionText = this.facilitatorDetails.Function;
      const isSelectedFunctionZero = this.selectedFunction === 0;
      const isFunctionInList = this.functionList.some(data => data.ID === this.selectedFunction);
      this.functionText = !(isSelectedFunctionZero || isFunctionInList);
      if (this.functionText) {
        this.functionList.push({ ID: this.selectedFunction, Name: this.facilitatorDetails.Function });
        this.selectedFunction = this.facilitatorDetails.ServiceFunctionID;
      }

      this.selectedService = this.facilitatorDetails.ServiceAreaID;
      this.selectedServiceText = this.facilitatorDetails.Servicearea;
      const isSelectedServiceZero = this.selectedService === 0;
      const isServiceInList = this.serviceList.some(data => data.ServiceAreaID === this.selectedService);
      this.serviceAreaText = !(isSelectedServiceZero || isServiceInList);
      if (this.serviceAreaText) {
        this.serviceList.push({ ServiceAreaID: this.selectedService, ServiceAreaName: this.facilitatorDetails.Servicearea });
        this.selectedService = this.facilitatorDetails.ServiceAreaID;
      }

      this.selectedLevel = this.facilitatorDetails.PositionID;

      this.selectedIndustry = this.facilitatorDetails.IndustryID;
      this.selectedIndustryText = this.facilitatorDetails.Industry;
      const isSelectedIndustryZero = this.selectedIndustry === 0;
      const isIndustryInList = this.industryList.some(data => data.ID === this.selectedIndustry);
      this.industryText = !(isSelectedIndustryZero || isIndustryInList);
      if (this.industryText) {
        this.industryList.push({ ID: this.selectedIndustry, Name: this.facilitatorDetails.Industry });
        this.selectedIndustry = this.facilitatorDetails.IndustryID;
      }

      this.selectedSector = this.facilitatorDetails.SectorID;
      this.selectedSectorText = this.facilitatorDetails.Sector;
      const isSelectedSectorZero = this.selectedSector === 0;
      const isSectorInList = this.sectorList.some(data => data.SectorID === this.selectedSector);
      this.sectorText = !(isSelectedSectorZero || isSectorInList);
      if (this.sectorText) {
        this.sectorList.push({ SectorID: this.selectedSector, SectorName: this.facilitatorDetails.Sector });
        this.selectedSector = this.facilitatorDetails.SectorID;
      }
      this.selectedDeliveryMethods = this.facilitatorDetails.sessionFormatID ? this.facilitatorDetails.sessionFormatID.split(',') : [];
      this.selectedCertification = this.facilitatorDetails.CertificationlevelID ? this.facilitatorDetails.CertificationlevelID : 0;
      this.imIntrestedWith = (this.facilitatorDetails.ImIntrestedWith) !== null && (this.facilitatorDetails.ImIntrestedWith) !== undefined ? this.facilitatorDetails.ImIntrestedWith : '';
      this.iEnjoyBecause = (this.facilitatorDetails.IEnjoyBecause) !== null && (this.facilitatorDetails.IEnjoyBecause) !== undefined ? this.facilitatorDetails.IEnjoyBecause : '';
      this.iBring = (this.facilitatorDetails.IBring) !== null && (this.facilitatorDetails.IBring) !== undefined ? this.facilitatorDetails.IBring : '';
      this.loadMethodOfDeliveryCheckboxValue();
      if (this.selectedCertification == 2) {
        $('#option1').prop('checked', true);
        $('#option2').prop('checked', false);
      }

      if (this.selectedCertification == 1) {
        $('#option2').prop('checked', true);
        $('#option1').prop('checked', false);
      }

    }

  }

  loadMethodOfDeliveryCheckboxValue(): void {
    this.deliveryMethods.forEach(data => {
      data.isChecked = (this.selectedDeliveryMethods.length > 0 &&
        this.selectedDeliveryMethods.indexOf(data.SessionFormatID.toString()) !== -1) ? true : false
    })
  }

  loadDropdownConditionally() {

    if (this.facilitatorDetails.CountryID == '23') {
      this.countryList = this.masterData['Countries'].filter(data => !data.IsMDR);
    }
    else {
      this.countryList = this.masterData['Countries'].filter(data => !data.IsMDR).filter(item => item.ID != "23");
    }
    this.functionList = this.masterData['ServiceFunctions'].filter(data => !data.IsMDR && data.ID != 20);
    this.industryList = this.masterData['Industries'].filter(data => !data.IsMDR && data.ID != 23);

  }

  onCountrySelect(country) {
    this.isMDRData = [23, 259, 265].includes(country);
    if (Number(country)) {
      this.updateStatesBasedOnCountry(Number(country));
      this.updateCitiesBasedOnCountry(Number(country));
    }
    this.checkError();
  }

  onStateSelect(state) {
    if (state) {
      this.cityList = this.facilitatorService.onDropdownSelect(state, this.masterData, 'Cities', 'StateID');
    }
    this.selectedCity = 0;
  }

  onFunctionSelect(functionId) {
    this.serviceList = this.facilitatorService.onDropdownSelect(functionId, this.masterData, 'ServiceAreas', 'ServiceFunctionID');

    this.selectedService = 0;
    this.checkError();
  }

  onIndustrySelect(industryId) {
    this.sectorList = this.facilitatorService.onDropdownSelect(industryId, this.masterData, 'Sectors', 'IndustryID');
    this.selectedSector = 0;
    this.checkError();
  }

  onLevelSelect(levelId) {
    this.checkError();
  }

  updateStatesBasedOnCountry(country) {
    this.stateList = this.facilitatorService.onDropdownSelect(country, this.masterData, 'States', 'CountryID');
    this.selectedState = 0;
  }

  updateCitiesBasedOnCountry(country) {
    if (this.stateList.length > 0 && (country == 23 || country == 0 || country == 259 || country == 265)) {
      this.cityList = [];
      this.stateList.forEach(state => {
        const cities = this.facilitatorService.onDropdownSelect(state.ID, this.masterData, 'Cities', 'StateID');
        cities.forEach(city => {
          this.cityList.push(city);
        });
        this.cityList = this.cityList.toSorted((a, b) => a.CityName.localeCompare(b.CityName));
      });
    }
    else if (this.selectedState === 0) {
      this.cityList = [];
    }
    this.selectedCity = 0;
  }

  updateServiceFunctionBasedOnCountry(country) {
    if (!this.editMode) {
      this.functionList = this.facilitatorService.updateListBasedOnCountry(country, this.masterData, 'ServiceFunctions');
    }
    this.selectedFunction = 0;
  }

  updateServiceAreaBasedOnCountry(country) {
    this.serviceList = this.facilitatorService.updateListBasedOnCountry(country, this.masterData, 'ServiceAreas');
    this.selectedService = 0;
  }

  updateIndustriesBasedOnCountry(country) {
    this.industryList = this.facilitatorService.updateListBasedOnCountry(country, this.masterData, 'Industries');
    this.selectedIndustry = 0;
  }

  updateSectorsBasedOnCountry(country) {
    this.sectorList = this.facilitatorService.updateListBasedOnCountry(country, this.masterData, 'Sectors');
    this.selectedSector = 0;
  }

  applyValidation() {
    const roleId = this.userRoleService.userRoleId;
    const loggedInUserID = this.userRoleService.loggedInUserId;
    const assignedCountries = this.userRoleService.userAssignedCountries;

    this.disableName = true;
    this.disableEmail = true;
    this.disableCountry = true;
    this.disableState = true;
    this.disableCity = true;
    this.disableFunction = true;
    this.disableService = true;
    this.disableIndustry = true;
    this.disableSector = true;
    this.disableLevel = true;
    this.disableRadioButtons = true;
    this.disableimIntrestedWith = true;
    this.disableiEnjoyBecause = true;
    this.disableiBring = true;
    this.showEditLabel = false;
    this.showFooter = false;
    this.disableSave = true;
    this.showArrow = false;
    this.error = false;

    if (this.facilitatorDetails && this.facilitatorDetails.UserID === loggedInUserID) {

      this.disableCountry = false;
      this.disableState = false;
      this.disableCity = false;
      this.disableFunction = false;
      this.disableService = false;
      this.disableIndustry = false;
      this.disableSector = false;
      this.disableLevel = false;
      this.disableimIntrestedWith = false;
      this.disableiEnjoyBecause = false;
      this.disableiBring = false;
      this.showEditLabel = true;
      this.showFooter = true;
      this.disableSave = true;
      this.showArrow = true;
    }

    if (assignedCountries && assignedCountries.length > 0) {
      assignedCountries.map(country => {
        if (country == this.facilitatorDetails.CountryID && roleId === 3) {
          this.showEditLabel = true;
          this.showFooter = true;
          this.disableRadioButtons = false;
          this.disableSave = false;
        }
      });
    }

    if (roleId === 1) {
      this.disableCountry = false;
      this.disableState = false;
      this.disableCity = false;
      this.disableFunction = false;
      this.disableService = false;
      this.disableIndustry = false;
      this.disableSector = false;
      this.disableLevel = false;
      this.disableRadioButtons = false;
      this.disableimIntrestedWith = false;
      this.disableiEnjoyBecause = false;
      this.disableiBring = false;
      this.showEditLabel = true;
      this.showFooter = true;
      this.disableSave = true;
      this.showArrow = true;
    }


    //    this.disableCountry = false;
    //    this.disableState = false;
    //    this.disableCity = false;
    //    this.disableFunction = false;
    //    this.disableService = false;
    //    this.disableIndustry = false;
    //    this.disableSector = false;
    //    this.showEditLabel = true;
    //    this.showFooter = true;
    //    this.disableSave = true;
    //    this.showArrow = true;
    //} else {
    //    this.editMode = false;


    if (roleId === 5 || roleId === 6 || roleId === 8) {

      this.disableName = true;
      this.disableEmail = true;
      this.disableCountry = true;
      this.disableState = true;
      this.disableCity = true;
      this.disableFunction = true;
      this.disableService = true;
      this.disableIndustry = true;
      this.disableSector = true;
      this.disableLevel = true;
      this.disableRadioButtons = true;
      this.disableimIntrestedWith = true;
      this.disableiEnjoyBecause = true;
      this.disableiBring = true;
      this.showEditLabel = false;
      this.showFooter = false;
      this.disableSave = true;
      this.showArrow = false;
      this.error = false;
    }
    if (this.facilitatorDetails?.PersonID) {
      this.disableFunction = true;
      this.disableCountry = true;
      this.disableState = true;
      this.disableCity = true;
      this.disableService = true;
      this.disableSector = true;
      this.disableIndustry = true;
    }

  }

  checkError() {
    this.error = false;
    if ((this.selectedCountry == 0 && !this.disableCountry) || (this.selectedFunction == 0 && !this.disableFunction) ||
      (this.selectedIndustry == 0 && !this.disableIndustry) || (this.selectedLevel == 0 && !this.disableLevel)) {
      this.error = true;
    }
  }

  SaveData() {
    this.checkError();

    if (!this.error) {
      const presenter = {
        countryID: Number(this.selectedCountry),
        stateID: Number(this.selectedState),
        cityID: Number(this.selectedCity),
        officeID: 0,
        servicefunctionID: Number(this.selectedFunction),
        serviceAreaID: Number(this.selectedService),
        servicelineID: 0,
        joblevelID: Number(this.selectedLevel),
        industryID: Number(this.selectedIndustry),
        sectorID: Number(this.selectedSector),
        certificationlevelID: Number(this.selectedCertification),
        minDeloitteSessionsFacilitated: 0,
        maxDeloitteSessionsFacilitated: 0,
        minClientSessionsFacilitated: 0,
        maxClientSessionsFacilitated: 0,
        UserID: this.facilitatorDetails.UserID,
        PresenterID: this.facilitatorDetails.PresenterID,
        Email: this.selectedEmail,
        ImIntrestedWith: this.imIntrestedWith,
        IEnjoyBecause: this.iEnjoyBecause,
        IBring: this.iBring
      }

      this.facilitatorService.saveFacilitator(presenter).pipe(takeUntil(this.subscription)).subscribe(res => {
        if (res) {
          this.updatedFacilitator.emit(true);
        }
      });
    }
  }
}
